<template>
  <footer class="footer">
    <div class="some-bar footer__some-bar">
      <div class="some-bar__buttons">
        <a href="https://www.facebook.com/kamblysa" target="_blank" class="some-bar__button some-bar__button--fb icon"></a>
        <a href="https://www.instagram.com/kambly_sa/" target="_blank" class="some-bar__button some-bar__button--instagram icon"></a>
        <a href="https://ch.linkedin.com/company/kambly-sa" target="_blank" class="some-bar__button some-bar__button--linkedin icon"></a>
        <a href="https://www.youtube.com/channel/UCsBkQ1EOoXE1rhWr8-IvL_g" target="_blank" class="some-bar__button some-bar__button--youtube icon"></a>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-lg-3">
          <p class="footer__copyright">© {{ new Date().getFullYear() }} Kambly SA</p>
          <p class="footer__copyright footer__copyright--address">Mühlestrasse 4, 3555 Trubschachen, Schweiz</p>
        </div>
        <div class="col-md-6 d-flex justify-content-center justify-content-md-end ml-lg-auto flex-column">
          <div class="footer__legal-links">
            <a :href="content.footerContent.disclaimerLink" target="_blank" class="footer__legal-link">
              {{ content.footerContent.disclaimerTitle }}
            </a>
            <a :href="content.footerContent.dataLink" target="_blank" class="footer__legal-link">
              {{ content.footerContent.dataTitle }}
            </a>
            <a :href="content.footerContent.impressumLink" target="_blank" class="footer__legal-link">
              {{ content.footerContent.impressumTitle }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'content'
    ])
  }
}
</script>

<style lang="scss">
.some-bar__button--linkedin {
  &::before {
    content: "\e92d";
    font-size: 18px;
    margin-top: 6px;
  }
}

.some-bar {
  .some-bar__buttons {
    &:first-child {
      &::before,
      &::after {
        width: calc(50% - 88px);
      }
    }
  }
}
</style>